<template>
  <v-dialog v-model="dialog" width="800" :persistent="true">
    <template v-slot:activator="{ on }">
      <permission-tooltip
          :permission="hasPermission('patient_notes_create')"
          :tooltip="{right: true, bottom: false, attach: false}"
      >
        <v-btn color="primary" class="ml-0 mr-0" @click="open" :disabled="!hasPermission('patient_notes_create')">
          {{ 'app.notes_in_patient_panel.add' | trans }}
        </v-btn>
      </permission-tooltip>
    </template>
    <v-card>
      <v-toolbar card dark color="primary">
        <v-toolbar-title>{{ modalTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark small @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout row wrap>
            <v-flex xs12>
              <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                      v-model="date"
                      @blur="note.created_at = parseDate(date)"
                      :label="'app.date' | trans"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                      :rules="rules.created_at"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="note.created_at" @input="menu = false"
                               locale="pl-pl" first-day-of-week="1"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                  :label="'app.notes_in_patient_panel.content' | trans"
                  v-model="note.note"
                  :rules="rules.content"
                  full
                  rows="10"
                  outline
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-form>

      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="close">
          {{ 'app.close' | trans }}
        </v-btn>
        <v-btn color="primary" @click="save" :disabled="!valid" :loading="loading">
          {{ 'app.save' | trans }}
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import {trans} from "../../app";
import NoteService from "../../services/NoteService";
import {mapActions, mapGetters} from "vuex";
import moment from 'moment';
import {FORMAT_DATE, SYSTEM_DATE} from "../../utils/dateFormatter";

export default {
  data: function () {
    return {
      noteId: null,
      date: '',
      menu: false,
      dialog: false,
      valid: false,
      loading: false,
      note: {
        note: '',
        created_at: '',
      }
    };
  },
  props: {
    currentNote: Object,
    patientId: Number,
  },
  methods: {
    ...mapActions(['fetchNotes']),
    open() {
      this.$refs.form.reset();
      this.noteId = null;
      this.dialog = true;
      if (!this.note.created_at) {
        this.note.created_at = moment().format(SYSTEM_DATE);
      }
    },
    close() {
      this.$refs.form.reset();
      this.dialog = false;
      this.note.note = '';
      this.note.created_at = '';
      this.$emit('closed');
    },
    async save() {
      if (this.$refs.form.validate() === false) {
        return;
      }

      this.loading = true;
      const noteService = new NoteService();
      let note = {
        note: this.note.note,
        created_at: this.note.created_at
      };
      if (this.noteId) {
        note.id = this.noteId;
        await noteService.updateNote(this.patientId, note);
      } else {
        await noteService.saveNote(this.patientId, note);
      }
      if (this.noteId) {
        this.$toast.success(trans('app.actions.edited', {name: trans('app.note_accusative')}));
      } else {
        this.$toast.success(trans('app.actions.added', {name: trans('app.note_accusative')}));
      }
      await this.fetchNotes({
        patientId: this.patientId,
        query: {
          rowsPerPage: 50,
          sortBy: 'created_at',
          descending: true,
        }
      });

      this.loading = false;
      this.close();
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      return moment(date).format(FORMAT_DATE)
    },
    parseDate(date) {
      if (!date) {
        return '';
      }
      return moment(date, FORMAT_DATE).format(SYSTEM_DATE);
    },
  },
  computed: {
    ...mapGetters(['hasPermission']),
    rules: function () {
      return {
        content: [
          v => !!v || trans('app.validation.required'),
          v => v && v.length >= 1 || trans('app.notes_in_patient_panel.validation.content.min', {min: '1'}),
          v => v && v.length <= 5000 || trans('app.notes_in_patient_panel.validation.content.max', {max: '5000'}),
        ],
        created_at: [
          v => !!v || trans('validation.required', {'attribute': trans('app.date')}),
        ]
      };
    },
    modalTitle: function () {
      const key = this.noteId ? 'app.notes_in_patient_panel.edit' : 'app.notes_in_patient_panel.add';

      return trans(key);
    }
  },
  watch: {
    'note.created_at'(createdAt) {
      this.date = createdAt ? this.formatDate(createdAt) : '';
    },
    currentNote: function (note) {
      if (note === null) {
        this.noteId = null;
        this.note.note = '';
        this.note.created_at = '';
      } else {
        this.noteId = note.id;
        this.note.note = note.note;
        this.note.created_at = moment(note.created_at).format(SYSTEM_DATE);
      }
    }
  }
}
</script>
